module.exports = __webpack_public_path__ + "img/dianshang-wechat.73cd28d7.png";